module.exports = __webpack_public_path__ + "static/BTP-graphic1-400-d30351c44459e7b776281f33d2cee730.png";